import React, { Component } from 'react';
import { message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';
import ReSolidifyModal from './ReSolidifyModal';

const Config = [{
        name: '主PM',
        key: 'mainPm',
        obj: 'mainPmUserPercentBonus',
    }, {
        name: '研究中心LM',
        key: 'Lm',
        obj: 'lmUserPercentBonus',
    }, {
        name: '客户CSA',
        key: 'CSA',
        obj: 'customCsaUserPercentBonus',
    }, {
        name: 'CSA负责人',
        key: 'CSAL',
        obj: 'csaHeaderUserPercentBonus',
    }, {
        name: '主领域leader/上级主管',
        key: 'mainLeader',
        obj: 'ldManagerUserPercentBonus',
    }, {
        name: '业务线/区域负责人',
        key: 'line',
        obj: 'lineAreaHeadUserPercentBonus',
    }, {
        name: '临床负责人',
        key: 'clinical',
        obj: 'clinicalHeadUserPercentBonus',
    }, {
        name: 'Pool',
        key: 'pool',
        obj: 'poolUserPercentBonus',
    },
]
// 最新更新时间，总账冲销，Pool，临床负责人，客户代码

class List extends Component {
    state = {
        loading: false,
        pagination: {
            pageSize:10,
            current:1,
        },
        searchParams: {},
        data: [],
        coList: { 
            coPmCount: 0, 
            coLeaderCount: 0,
        }
    }

    filterDataWithoutObject = (params) => {
        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            if (typeof value !== 'object') {
                obj[key] = value;
            }
        }
        return obj;
    }

    loadData = () =>{
        this.setState({ loading: true });
        const { pagination, searchParams } = this.state;
        const { current, pageSize  } = pagination;
        const params = this.filterDataWithoutObject(searchParams);
        
        const options = {
            method: 'POST',
            url: API_URL.home.queryContractBackQuarterReport,
            data: {   
                offset: current,
                limit: pageSize,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    coList: res.data,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination,searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {searchParams,...params},
        }, () => {
            this.loadData();
        });
    }

    export = (params) => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.home.exportContractBackQuarterReport;
        this.addToDownloadSite({ ...sortParams, ...params }, url, 'CONTRACT_BACK_REPORT');
    }

    reSolidify = () => {
        this.reSolidifyRef.show();
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { asynchronousExportId } = res;
                const params = { ...searchArray, asynchronousExportId }
                const options = {
                    method: 'POST',
                    url,
                    data: params,
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                    },
                };
                $.sendRequest(options);
            },
        };
        $.sendRequest(options);
    }

    renderContractBackDifferenceBonus = ( record, key, num = '') => {
        const { type }=this.props;
        return type == 'Year' ? record[`${key}ContractBackDifferenceBonus${num}`] : record[`${key}ContractBackBonus${num}`]
    }

    columnsTitle = title => {
        const { type }=this.props;
        return `${title}${ type == 'Year' ? '差额' : '' }`
    }

    getColumns = () => {
        const { coList: { coPmCount= 0, coLeaderCount= 0 } } = this.state;
        
        const columns = [{
            title: '项目识别码',
            dataIndex: 'investigationIdentifyCode',
            key: 'investigationIdentifyCode',
            fixed: 'left',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '是否为单中心管理项目',
            dataIndex: 'singleInvStr',
            key: 'singleInvStr',
            width: 100,
        }, {
            title: '是否从中心请款',
            dataIndex: 'centerContractBackName',
            key: 'centerContractBackName',
            width: 100,
        }, {
            title: '主PM',
            dataIndex: 'mainPmUser',
            key: 'mainPmUser',
            width: 150,
        }, {
            title: '主PM-分配系数（%）',
            dataIndex: 'mainPmPercent',
            key: 'mainPmPercent',
            width: 100,
            render: text => text ? `${text}%` : ''
        }, {
            title: this.columnsTitle('主PM-回款奖金'),
            dataIndex: 'mainPmContractBackBonus',
            key: 'mainPmContractBackBonus',
            width: 100,
            render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'mainPm')
        }]

        for( let i = 0 ; i < coPmCount; i++ ){
            columns.push(
                {
                    title: `CO-PM${ i + 1 }`,
                    dataIndex: `CO-PMUser${ i + 1 }`,
                    key: `CO-PMUser${ i + 1 }`,
                    width: 150,
                }, {
                    title: `CO-PM${ i + 1 }-分配系数（%）`,
                    dataIndex: `CO-PMPercent${ i + 1 }`,
                    key: `CO-PMPercent${ i + 1 }`,
                    width: 100,
                    render: text => text ? `${text}%` : ''
                }, {
                    title: this.columnsTitle(`CO-PM${ i + 1 }-回款奖金`),
                    dataIndex: `CO-PMContractBackBonus${ i + 1 }`,
                    key: `CO-PMContractBackBonus${ i + 1 }`,
                    width: 100,
                    render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'CO-PM', i + 1)
                }
            )
        }

        columns.push(
            {
                title: `研究中心LM`,
                dataIndex: `LmUser`,
                key: `LmUser`,
                width: 150,
            }, {
                title: `研究中心LM-分配系数（%）`,
                dataIndex: `LmPercent`,
                key: `LmPercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`研究中心LM-回款奖金`),
                dataIndex: `LmContractBackBonus`,
                key: `LmContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'Lm')
            }, {
                title: `JDE项目号`,
                dataIndex: `jdeCode`,
                key: `jdeCode`,
                width: 100,
            }, {
                title: `业务线`,
                dataIndex: `lineOfBusinessString`,
                key: `lineOfBusinessString`,
                width: 100,
            }, {
                title: `执行业务线二级分类`,
                dataIndex: `secondLineNames`,
                key: `secondLineNames`,
                width: 100,
            }, {
                title: `计收入确认方式`,
                dataIndex: `contractTypeName`,
                key: `contractTypeName`,
                width: 100,
            }, {
                title: `发票号`,
                dataIndex: `remark`,
                key: `remark`,
                width: 100,
            }, {
                title: `客户代码`,
                dataIndex: `addressNumber`,
                key: `addressNumber`,
                width: 100,
            }, {
                title: `客户名称`,
                dataIndex: `alphaname`,
                key: `alphaname`,
                width: 100,
            }, {
                title: `收入归属单位`,
                dataIndex: `unitOfBelongingName`,
                key: `unitOfBelongingName`,
                width: 100,
            }, {
                title: `客户CSA`,
                dataIndex: `CSAUser`,
                key: `CSAUser`,
                width: 150,
            }, {
                title: `客户CSA-分配系数（%）`,
                dataIndex: `CSAPercent`,
                key: `CSAPercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`客户CSA-回款奖金`),
                dataIndex: `CSAContractBackBonus`,
                key: `CSAContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'CSA')
            }, {
                title: `CSA负责人`,
                dataIndex: `CSALUser`,
                key: `CSALUser`,
                width: 150,
            }, {
                title: `CSA负责人-分配系数（%）`,
                dataIndex: `CSALPercent`,
                key: `CSALPercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`CSA负责人-回款奖金`),
                dataIndex: `CSALContractBackBonus`,
                key: `CSALContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'CSAL')
            }, {
                title: `领域leader/上级主管`,
                dataIndex: `mainLeaderUser`,
                key: `mainLeaderUser`,
                width: 150,
            }, {
                title: `主领域leader/上级主管-分配系数（%）`,
                dataIndex: `mainLeaderPercent`,
                key: `mainLeaderPercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`主领域leader/上级主管-回款奖金`),
                dataIndex: `mainLeaderContractBackBonus`,
                key: `mainLeaderContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'mainLeader')
            }, 
        )

        for( let i = 0 ; i < coLeaderCount; i++ ){
            columns.push(
                {
                    title: `CO-领域leader${ i + 1 }`,
                    dataIndex: `CO-leaderUser${ i + 1 }`,
                    key: `CO-leaderUser${ i + 1 }`,
                    width: 150,
                }, {
                    title: `CO-领域leader${ i + 1 }-分配系数（%）`,
                    dataIndex: `CO-leaderPercent${ i + 1 }`,
                    key: `CO-leaderPercent${ i + 1 }`,
                    width: 100,
                    render: text => text ? `${text}%` : ''
                }, {
                    title: this.columnsTitle(`CO-领域leader${ i + 1 }-回款奖金`),
                    dataIndex: `CO-leaderContractBackBonus${ i + 1 }`,
                    key: `CO-leaderContractBackBonus${ i + 1 }`,
                    width: 100,
                    render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'CO-leader', i + 1)
                }
            )
        }

        columns.push(
            {
                title: `业务线/区域负责人`,
                dataIndex: `lineUser`,
                key: `lineUser`,
                width: 150,
            }, {
                title: `业务线/区域负责人-分配系数（%）`,
                dataIndex: `linePercent`,
                key: `linePercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`业务线/区域负责人-回款奖金`),
                dataIndex: `lineContractBackBonus`,
                key: `lineContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'line')
            }, {
                title: `临床负责人-分配系数（%）`,
                dataIndex: `clinicalPercent`,
                key: `clinicalPercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`临床负责人-回款奖金`),
                dataIndex: `clinicalContractBackBonus`,
                key: `clinicalContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'clinical')
            }, {
                title: `Pool-分配系数（%）`,
                dataIndex: `poolPercent`,
                key: `poolPercent`,
                width: 100,
                render: text => text ? `${text}%` : ''
            }, {
                title: this.columnsTitle(`Pool-回款奖金`),
                dataIndex: `poolContractBackBonus`,
                key: `poolContractBackBonus`,
                width: 100,
                render: ( text, record ) => this.renderContractBackDifferenceBonus(record, 'pool')
            }, {
                title: `发票描述（包含Milstone和PT非PT）`,
                dataIndex: `reference`,
                key: `reference`,
                width: 100,
            }, {
                title: `总账冲销`,
                dataIndex: `gloffSet`,
                key: `gloffSet`,
                width: 100,
            }, {
                title: `本位币种`,
                dataIndex: `baseCurrency`,
                key: `baseCurrency`,
                width: 100,
            }, {
                title: `结算币种`,
                dataIndex: `currencyCode`,
                key: `currencyCode`,
                width: 100,
            }, {
                title: `汇率`,
                dataIndex: `exchangeRate`,
                key: `exchangeRate`,
                width: 100,
            }, {
                title: `发票金额（不含税）`,
                dataIndex: `taxableAmount`,
                key: `taxableAmount`,
                width: 100,
            }, {
                title: `发票金额（税）`,
                dataIndex: `tax`,
                key: `tax`,
                width: 100,
            }, {
                title: `发票金额（含税总额）总金额`,
                dataIndex: `grossAmount`,
                key: `grossAmount`,
                width: 100,
            }, {
                title: `账期`,
                dataIndex: `paymentTerms`,
                key: `paymentTerms`,
                width: 100,
            }, {
                title: `开票时间`,
                dataIndex: `invoiceDate`,
                key: `invoiceDate`,
                width: 100,
            }, {
                title: `到期日期`,
                dataIndex: `dueDate`,
                key: `dueDate`,
                width: 100,
            }, {
                title: `账龄`,
                dataIndex: `aging`,
                key: `aging`,
                width: 100,
            }, {
                title: `确认收款金额`,
                dataIndex: `receivingAmount`,
                key: `receivingAmount`,
                width: 100,
            }, {
                title: '确认收款金额(不含税)',
                dataIndex: 'receivingAmountNoTax',
                key: 'receivingAmountNoTax',
                width: 100,
            }, {
                title: `收款日期`,
                dataIndex: `dateInvoiceClosed`,
                key: `dateInvoiceClosedDate`,
                width: 100,
            }, {
                title: `确认收款年月`,
                dataIndex: `dateInvoiceClosed`,
                key: `dateInvoiceClosedYearMonth`,
                width: 100,
                render: text => text ? text.slice(0,7) : ''
            }, {
                title: `收款号`,
                dataIndex: `receiptNumber`,
                key: `receiptNumber`,
                width: 100,
            }, {
                title: `最新更新时间`,
                dataIndex: `lastUpdateTime`,
                key: `lastUpdateTime`,
                width: 100,
            }, {
                title: `请款单号`,
                dataIndex: `invoiceNumber`,
                key: `invoiceNumber`,
                width: 100,
            }, {
                title: `费用类型`,
                dataIndex: `expenseType`,
                key: `expenseType`,
                width: 100,
            }, 
        )

        return columns
    }

    getDataSource = () => {
        const { data } = this.state;
        const newDate = [];
        data.forEach( (record, index) => {
            newDate.push({...this.filterDataWithoutObject(record)})
            const {
                coPmUserPercentBonusList = [],
                coLeaderUserPercentBonusList = [],
            } = record;
            Config.forEach( el => {
                const { percent = null, userNameCodes = null, contractBackBonus = null, contractBackDifferenceBonus = null } = record[el.obj] || {};
                newDate[index][`${el.key}User`] = userNameCodes;
                newDate[index][`${el.key}Percent`] = percent;
                newDate[index][`${el.key}ContractBackBonus`] = contractBackBonus;
                newDate[index][`${el.key}ContractBackDifferenceBonus`] = contractBackDifferenceBonus;
            });
            (coPmUserPercentBonusList || []).forEach( ( el, num ) => {
                const { percent = null, userNameCodes = null, contractBackBonus = null, contractBackDifferenceBonus = null} = el;
                newDate[index][`CO-PMUser${num + 1}`] = userNameCodes;
                newDate[index][`CO-PMPercent${num + 1}`] = percent;
                newDate[index][`CO-PMContractBackBonus${num + 1}`] = contractBackBonus;
                newDate[index][`CO-PMContractBackDifferenceBonus${num + 1}`] = contractBackDifferenceBonus;
            });
            (coLeaderUserPercentBonusList || []).forEach( ( el, num ) => {
                const { percent = null, userNameCodes = null, contractBackBonus = null, contractBackDifferenceBonus = null} = el;
                newDate[index][`CO-leaderUser${num + 1}`] = userNameCodes;
                newDate[index][`CO-leaderPercent${num + 1}`] = percent;
                newDate[index][`CO-leaderContractBackBonus${num + 1}`] = contractBackBonus;
                newDate[index][`CO-leaderContractBackDifferenceBonus${num + 1}`] = contractBackDifferenceBonus;
            });
        })
        return newDate;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, pagination } = this.state;
        const dataSource = this.getDataSource();
        const { type }=this.props;
        return (
            <div>
                <Filter search={this.search} export={this.export} reSolidify={this.reSolidify} type={type}/>
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>{`注：由于数据量过大，页面仅展示其中一个项目的数据，请导出后查看完整数据`}</div>
                <TableC
                    loading={loading}
                    scrollY={460}
                    pagination={pagination}
                    columns={this.getColumns()}
                    data={dataSource}
                    onChange={this.handleTableChange}
                />
                <ReSolidifyModal ref={el => this.reSolidifyRef = el} />
            </div>
        )
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/homePage/returnedMoney/List.js